import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchProcessorList = createProvider(api.fetchProcessorList)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch processor list aborted');
    } else {
      console.error('Fetch processor list was failed:', error);
    }
    throw error;
  });
